import styled from 'styled-components'

export const ThankYouTitleUi = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`
